import type { PriceCleaningChoice, PriceCleaningType } from '@/domain';

type CleaningDisplay = { type: 'fee' | 'text'; value: string } | null;

export const getCleaningDisplay = (
    cleaningOption: string,
    cleaningChoice: PriceCleaningChoice,
    cleaningType: PriceCleaningType | null,
    showConfirmedCleaning: boolean,
): CleaningDisplay => {
    switch (cleaningOption) {
        case 'FEE':
            return { type: 'fee', value: '' };
        case 'INCLUDED':
            return { type: 'text', value: 'Inkludert' };
        case 'GUEST_CLEANS':
            return { type: 'text', value: 'Leietaker vasker' };
        case 'OPTIONAL_GUEST_CLEANS_OR_FEE':
            if (!showConfirmedCleaning) {
                if (cleaningChoice === 'FEE') return { type: 'fee', value: '' };
                if (cleaningChoice === 'GUEST_CLEANS') return { type: 'text', value: 'Leietaker velger' };
                if (cleaningChoice === null && cleaningType === 'GUEST_CLEANS_CHOSEN') return { type: 'text', value: 'Leietaker velger' };
                return { type: 'text', value: 'Leietaker velger' };
            }
            return cleaningType === 'FEE_CHOSEN' ? { type: 'fee', value: '' } : { type: 'text', value: 'Leietaker vasker' };
        default:
            return null;
    }
};
